import { pxToRem } from '../../../core/utils/functions';
import { C_GRAY } from '../../utils/colors';

import { AccordionStyleProps } from './accordion-types';

import { css } from '@emotion/css';

export const useStyles = ({ borderColor }: AccordionStyleProps) => {
  return {
    item: css({
      '&:not(:last-child)': {
        borderBottom: `${pxToRem(1)} solid ${borderColor ?? C_GRAY}`,
      },
    }),
  };
};
